import { render, staticRenderFns } from "./RollerNews.vue?vue&type=template&id=74363d10&scoped=true&"
import script from "./RollerNews.vue?vue&type=script&lang=js&"
export * from "./RollerNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74363d10",
  null
  
)

export default component.exports